<template>
	<div>
		<form-dialog
			:appendToBody="true"
			:dialogVisible.sync="dialog_visable"
			:formData="formData"
			ref="formData"
			dialogWidth="600px"
			@handleClose="close"
		>
			<dialogtitle
				slot="title"
				title="对话分配"
				:subStyle="{ display: 'block', fontSize: '12px', marginLeft: 0 }"
			></dialogtitle>
			<dialogfooter
				slot="footer"
				:visible.sync="dialog_visable"
				@onclose="close"
				@confirm="submit"
			></dialogfooter>
		</form-dialog>
	</div>
</template>
<script>
import formDialog from '@/components/webManage/formDialog.vue';
import dialogtitle from '@/components/crm/crm-dialog-title.vue';
import dialogfooter from '@/components/crm/crm-dialog-footer.vue';
import Name from '@/components/crm/crm-form-name.vue';
import clueSer from '@/client/services/clue/clueSer.js';
import { mapGetters, mapActions } from 'vuex';
import { validRequired } from '@/common/elementValid.js';
import chatSer from '@/backend/services/chat/chatSer.js';
import customSer from '@/client/services/customerManage/customerSer.js';
export default {
	props: {
		summaryId: {
			type: String,
		},
		visible: {
			type: Boolean,
		},
		messengerUserId: null,
		type: null,
		followupId: null,
	},
	data() {
		let that = this;
		return {
			formData: {
				salesleadsId: {
					displayWith: () => false,
					formType: 'sky-input',
					value: '',
				},
				move: {
					label: '跟进人:',
					key: 'accountIds',
					value: '',
					multiple: false,
					options: that.getEmployee,
					formType: 'sky-select',
					props: {
						label: 'name',
						value: 'id',
					},
					placeholder: '请选择服务人员',
					rules: [validRequired('请选择服务人员', 'change')],
				},
			},
			dialog_visable: false,
			blongerIds: [],
			avatarUrl: '',
			employee: [],
		};
	},
	watch: {
		visible: {
			handler() {
				this.dialog_visable = this.visible;
				this.eventBus();
			},
		},
	},
	computed: {
		...mapGetters(['allChatList', 'chatListData']),
	},
	methods: {
		...mapActions(['getEmployeeList']),
		async getEmployee() {
			this.employee = await this.getEmployeeList();
			return this.employee;
		},
		eventBus() {
			let that = this;
			this.formData = {
				salesleadsId: {
					displayWith: () => false,
					formType: 'sky-input',
					value: this.summaryId,
				},
				move: {
					label: '跟进人:',
					key: 'accountIds',
					value: that.followupId,
					multiple: false,
					options: this.getEmployee,
					formType: 'sky-select',
					props: {
						label: 'name',
						value: 'id',
					},
					placeholder: '请选择服务人员',
					rules: [validRequired('请选择服务人员', 'change')],
					change(val) {
						if (that.employee && that.employee.length > 0) {
							that.employee.forEach(e => {
								if (e.id == val) {
									that.avatarUrl = e.avatarUrl;
								}
							});
						}
					},
				},
			};
		},
		close() {
			this.dialog_visable = false;
			this.$emit('update:visible', false);
		},
		submit() {
			this.$refs.formData.validate(async valid => {
				if (valid) {
					let res;

					if (this.type == 0) {
						let params = {
							messengerUserId: this.messengerUserId, //线索ID
							belongerId: this.formData.move.value, //跟进人ID
							// ids: this.blongerIds ? this.blongerIds : [], //之前跟进人ID
						};

						res = await chatSer.assignment(params);
					}

					if (this.type == 1) {
						let params = {
							salesleadsId: this.summaryId, //线索ID
							accountIds: [this.formData.move.value], //跟进人ID
							ids: [], //之前跟进人ID
						};
						res = await clueSer.transferClue(params);
					}

					if (this.type == 2) {
						res = await customSer.transferCustomer({
							customerId: this.summaryId,
							targetEmployeeId: this.formData.move.value,
						});
					}

					if (res) {
						this.dialog_visable = false;
						this.blongerIds = [];
						//对聊天列表数据进行处理，线索转移，跟进人字段更新，请求聊天记录接口，抽屉关闭

						//列表跟进人头像数据替换，
						// this.allChatList.forEach(e => {
						// 	if (e.id == this.summaryId) {
						// 		e.followupName = this.formData.move.value;
						// 		e.followupHeadPath = this.avatarUrl;
						// 	}
						// });
						// this.$store.dispatch('setAllChatList', this.allChatList);
						this.$emit('update:visible', false);
						let item;

						if (this.$route.name == 'chat') {
							item = this.chatListData.find(e => e.id == this.summaryId);
						} else {
							item = this.allChatList.find(e => e.id == this.summaryId);
						}
						this.$router.push({
							name: this.$route.name,
							query: {
								followupName: this.formData.move.value,
								type: item.type,
								id: item.id,
								tableId: item.tableId,
							},
						});
						this.$emit('changeName');

						this.$message.success(`操作成功`);
					} else {
						this.$message.info(`操作失败`);
					}
				}
			});
		},
	},
	mounted() {
		this.getEmployee();
	},
	components: {
		formDialog,
		dialogtitle,
		dialogfooter,
		Name,
	},
};
</script>
<style lang="scss">
.el-popper {
	z-index: 10000 !important;
}
</style>
